import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Trash2, Search, ExternalLink } from "lucide-react";
import api from "@/lib/api";

export default function AdminComments() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const load = () => api.get("/admin/comments").then((r) => setItems(r.data.items)).catch(() => {});
  useEffect(() => { load(); }, []);
  const remove = async (id) => {
    if (!window.confirm("Delete this comment?")) return;
    try { await api.delete(`/comments/${id}`); setItems(items.filter((c) => c.id !== id)); toast.success("Comment deleted"); } catch { toast.error("Failed"); }
  };
  const list = items.filter((c) => `${c.text} ${c.user_name} ${c.user_email} ${c.article_title}`.toLowerCase().includes(q.toLowerCase()));
  return (
    <div data-testid="admin-comments">
      <div className="flex flex-wrap items-center justify-between gap-3 mb-5">
        <div><h1 className="text-2xl font-bold text-white">Comments</h1><p className="text-sm text-white/50">{items.length} comments from public accounts. Comments appear instantly; delete anything inappropriate.</p></div>
        <div className="relative"><Search size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/30" />
          <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search comments…" data-testid="admin-comments-search" className="pl-9 pr-3 py-2 rounded-lg bg-black/30 border border-white/10 text-sm text-white w-64" /></div>
      </div>
      <div className="space-y-2">
        {list.map((c) => (
          <div key={c.id} className="card-surface rounded-xl p-4 flex gap-4" data-testid={`admin-comment-${c.id}`}>
            <div className="flex-1 min-w-0">
              <div className="flex flex-wrap items-center gap-2 text-xs text-white/40">
                <span className="font-semibold text-white">{c.user_name}</span><span>{c.user_email}</span><span>·</span><span>{new Date(c.created_at).toLocaleString()}</span>
              </div>
              <p className="text-sm text-white/80 mt-1.5 whitespace-pre-line break-words">{c.text}</p>
              <Link to={`/news/${c.article_slug}`} target="_blank" className="mt-2 inline-flex items-center gap-1 text-xs text-[hsl(var(--primary))]"><ExternalLink size={11} /> {c.article_title}</Link>
            </div>
            <button onClick={() => remove(c.id)} className="self-start p-2 rounded-md text-white/40 hover:text-red-400 hover:bg-white/5" data-testid={`admin-comment-delete-${c.id}`}><Trash2 size={16} /></button>
          </div>
        ))}
        {!list.length && <div className="card-surface rounded-xl p-10 text-center text-white/40">No comments.</div>}
      </div>
    </div>
  );
}
